import React, { ChangeEvent, FC, useRef } from 'react';
import { Form, Input, InputRef } from 'antd';

import styles from './input-with-currency.module.less';
import { Rule } from 'antd/lib/form';
import { NamePath } from 'antd/lib/form/interface';
import { DEFAULT_INPUT_MAX_NUMBER, ERROR_STATUS, ONBOARDING_CURRENCY_TYPE } from 'src/constants';

export interface ICurrencyInputProps {
	currency?: string;
	name: string | NamePath | undefined;
	dependencies?: NamePath[] | undefined;
	disabled?: boolean;
	placeholder?: string;
	initValue?: string | number | undefined;
	rules?: Rule[];
	max?: number;
	onDataChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}
const CurrencyInput: FC<ICurrencyInputProps> = ({
	currency,
	name,
	disabled,
	placeholder,
	rules,
	dependencies,
	max = DEFAULT_INPUT_MAX_NUMBER,
	onDataChange
}) => {
	const { status } = Form.Item.useStatus();

	const inputRef = useRef<InputRef>(null);
	const onClickParent = () => {
		!disabled && inputRef.current?.focus();
	};
	return (
		<div
			className={`${styles.currencyContainer} ${disabled ? styles.currencyContainerDisabled : ''} ${
				status === ERROR_STATUS && styles.formError
			}`}
			onClick={onClickParent}>
			<div className={styles.currency}>{currency || ONBOARDING_CURRENCY_TYPE.HKD}</div>
			<Form.Item
				name={name}
				rules={rules}
				noStyle
				required={false}
				dependencies={dependencies}
				normalize={(c: string, p) => {
					if (!c) {
						return '';
					}
					c = c.replaceAll(',', '');
					const newValue = Number(c);

					if (isNaN(newValue) || newValue > max) {
						return p || '';
					}
					return newValue.toLocaleString('en-US');
				}}>
				<Input
					ref={inputRef}
					disabled={disabled}
					placeholder={placeholder ? placeholder : '-'}
					bordered={false}
					onChange={onDataChange}
				/>
			</Form.Item>
		</div>
	);
};

export default CurrencyInput;
